/** @typedef {import('App/Agent/Theme/EditAgentThemeProps').default} Props */

import { translate } from '../../../App/Internationalization';
import { withThemeService } from 'service-container';
import EditTheme from 'App/shared/EditTheme';
import flags from '../../../shared/Flags';
import paths from '../../../config/local/paths';
import React from 'react';
import useIsGated from '../../../Hooks/Shared/useIsGated/useIsGated';

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
function EditAgentTheme(props) {
	const { isGated, isGettingData } = useIsGated(flags.branding.colorLogos);

	return (
		<EditTheme
			getTheme={props.themeService.getAgentTheme.bind(props.themeService)}
			heading={translate('global.header.edit_your_branding')}
			isGated={isGated}
			isGettingData={isGettingData}
			setFavicon={props.themeService.setAgentFavicon.bind(
				props.themeService
			)}
			setLogo={props.themeService.setAgentLogo.bind(props.themeService)}
			setTheme={props.themeService.setAgentTheme.bind(props.themeService)}
			subscriptionLink={paths.app.agent.subscription.root}
			userType="agent"
		/>
	);
}

// @ts-ignore
export default withThemeService(EditAgentTheme);
